module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/cm-gallery/cm-gallery-14-b071cf5eefee487d777c3843d5c28a0d.jpg";